exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-main-header{display:block}adp-main-header adp-menu-toggler{margin-right:20px;padding-right:15px;border-right:1px solid #bdbdbd}adp-main-header .main-header-logo{max-width:75px}adp-main-header .notification-wrap{display:none}@media only screen and (max-width:779px){adp-main-header adp-main-breadcrumb .main-breadcrumb{font-size:24px}adp-main-header adp-main-breadcrumb .main-breadcrumb li{margin-left:0}adp-main-header adp-main-breadcrumb .main-breadcrumb li.current i,adp-main-header adp-main-breadcrumb .main-breadcrumb li:not(.current){display:none}adp-main-header adp-main-breadcrumb .main-breadcrumb li a{padding:0}adp-main-header adp-main-breadcrumb .main-breadcrumb li span{margin-left:0}adp-main-header adp-menu-toggler{margin-right:15px;padding-right:0;border-right:none}adp-main-header .header-logo-wrap{display:none}adp-main-header .notification-wrap{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpMainHeader/adpMainHeader.less
// module id = 510
// module chunks = 0